export default __webpack_public_path__ + "static/media/img_area_75.6eb6d1b8.svg";